<template>
    <v-icon @click="openWindow">mdi-printer</v-icon>
</template>

<script>
import axios from "axios";

export default {
    name: 'PrintOrderButton',
    props: {
        orderId: {},
    },
    data: function(){
        return {
            orderAttrs: [],
            groupSetting: null
        }
    },
    methods: {
        getOrder: async function() {

            const api_url = this.$store.getters.getApiUrl + '/api/v1/order/getOrder/' + this.orderId

            if(this.orderId > 0){

                return axios({
                    method: 'GET',
                    headers: {
                        'Authorization': 'bearer ' + this.$store.getters.getAccessToken
                    },
                    url: api_url,
                    timeout: this.$store.getters.getApiRequestTimeLimit
                })
                .then(async response => {

                    this.orderAttrs.productName = response.data.title
                    this.orderAttrs.count1 = response.data.paperQuantity
                    this.orderAttrs.count2 = response.data.quantity
                    this.orderAttrs.paper1 = response.data.paperType1
                    this.orderAttrs.paper2 = response.data.paperType2
                    this.orderAttrs.size = response.data.paperSize
                    this.orderAttrs.color = response.data.color
                    this.orderAttrs.coating = response.data.coating
                    this.orderAttrs.postProcessing = response.data.postProcessing
                    this.orderAttrs.subsidiary = response.data.subsidiary
                    this.orderAttrs.floorPaper = response.data.floorPaper
                    this.orderAttrs.comment = response.data.commentForProcessing
                    this.orderAttrs.startDate = this.$day(response.data.estimateDate).format('YYYY-MM-DD')
                    this.orderAttrs.dueDate = this.$day(response.data.dueDate).format('YYYY-MM-DD')
                    this.orderAttrs.groupName = this.groupSetting.groupName
                    this.orderAttrs.groupAddress = this.groupSetting.groupAddress
                    this.orderAttrs.groupPhone = this.groupSetting.groupPhone

                    await this.getProcessStatus()

                })

            }else{

                alert('주문번호가 없습니다.\n개발자에게 문의하세요.')
                return false

            }
        },
        async getProcessStatus(){

            return axios({
                method: 'GET',
                headers: {
                    'Authorization': 'bearer ' + this.$store.getters.getAccessToken
                },
                url: this.$store.getters.getApiUrl + '/api/v1/order/getProcessStatus/' + this.orderId,
                timeout: this.$store.getters.getApiRequestTimeLimit
            })
                .then(response => {

                    const data = response.data

                    if(data){

                        let processes = ''

                        if(data.process1Name) {
                            processes += data.process1Name + ' > '
                        }

                        if(data.process2Name) {
                            processes += data.process2Name + ' > '
                        }

                        if(data.process3Name) {
                            processes += data.process3Name + ' > '
                        }

                        if(data.process4Name) {
                            processes += data.process4Name + ' > '
                        }

                        if(data.process5Name) {
                            processes += data.process5Name + ' > '
                        }

                        if(data.process6Name) {
                            processes += data.process6Name + ' > '
                        }

                        if(data.process7Name) {
                            processes += data.process7Name + ' > '
                        }

                        this.orderAttrs.processes = processes.slice(0, -3)

                    }

                })

        },
        async openWindow() {
            await this.getOrder()
            const qs = this.objectToQueryString(this.orderAttrs)

            // window.open(this.$store.getters.getApiUrl + '/printOrder.html?'+qs, "의뢰 작업서 출력", 'top=50,left=50,width=1120px,height=770px,status=no,menubar=no,location=no,titlebar=no,toolbar=no')

            this.windowRef = window.open(this.$store.getters.getApiUrl + '/printOrder.html?'+qs, "의뢰 작업서 출력", 'top=50,left=50,width=1120px,height=770px,status=no,menubar=no,location=no,titlebar=no,toolbar=no')
            // this.windowRef.document.body.appendChild(this.$el)
            // copyStyles(window.document, this.windowRef.document)
            this.windowRef.addEventListener('beforeunload', this.closeWindow)
        },
        objectToQueryString(object) {
            return Object.keys(object).map(function (key) {
                if(object[key] != null){
                    return key + '=' + encodeURI(object[key])
                }else{
                    return key + '=' + '​'
                }
            }).join('&');
        }
    },
  mounted() {
      this.groupSetting = this.$store.getters.getGroupSetting
  }
}
</script>